module.exports = __webpack_public_path__ + "static/media/pb-2.d500cdad.png";